function fileListFromArray(files: File[]): FileList {
  const list = {
    length: files.length,
    item: (index: number) => files[index] ?? null,
    *[Symbol.iterator]() {
      for (const file of files) {
        yield file;
      }
    },
  } as FileList;
  for (let i = 0; i < files.length; i += 1) {
    (list as unknown as Record<number, File>)[i] = files[i] as File;
  }
  return list;
}

type DataTransferLike = Pick<DataTransfer, 'files' | 'items'>;

export function extractFileListFromDataTransfer(dt: DataTransferLike | null): FileList | null {
  if (!dt) {
    return null;
  }

  if (dt.files && dt.files.length > 0) {
    return dt.files;
  }

  if (dt.items && dt.items.length > 0) {
    const files: File[] = [];
    for (let i = 0; i < dt.items.length; i += 1) {
      const item = dt.items[i];
      if (item.kind === 'file') {
        const file = item.getAsFile();
        if (file) {
          files.push(file);
        }
      }
    }
    if (files.length > 0) {
      if (typeof DataTransfer !== 'undefined') {
        const dataTransfer = new DataTransfer();
        files.forEach((file) => {
          dataTransfer.items.add(file);
        });
        return dataTransfer.files;
      }
      return fileListFromArray(files);
    }
  }

  return null;
}
